import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import PaymentMethodManagerService from "services/PaymentMethodManagerService";
import {
  activePaymentMethodManagerFail,
  activePaymentMethodManagerSuccess,
  createPaymentMethodManagerFail,
  createPaymentMethodManagerSuccess,
  detailPaymentMethodManagerFail,
  detailPaymentMethodManagerSuccess,
  listPaymentMethodManagerFail,
  listPaymentMethodManagerSuccess,
  updatePaymentMethodManagerSuccess,
  updatePaymentMethodManagerFail,
} from "store/actions";
import { deletePaymentMethodManagerFail, deletePaymentMethodManagerSuccess } from "./actions";
import {
  PAYMENT_METHOD_MANAGER_CREATE,
  PAYMENT_METHOD_MANAGER_DETAIL,
  PAYMENT_METHOD_MANAGER_LIST,
  PAYMENT_METHOD_MANAGER_UPDATE,
  PAYMENT_METHOD_MANAGER_DELETE
} from "./actionTypes";
function* fetchListPaymentMethodManager({ payload }) {
  try {
    const response = yield call(PaymentMethodManagerService.listPaymentMethodManager, payload);
    yield put(listPaymentMethodManagerSuccess(response));
  } catch (error) {
    yield put(listPaymentMethodManagerFail(errorMessage(error)));
  }
}

function* onUpdatePaymentMethodManager({ payload }) {
  try {
    const response = yield call(PaymentMethodManagerService.updatePaymentMethodManager, payload);
    yield put(updatePaymentMethodManagerSuccess(response));
  } catch (error) {
    yield put(updatePaymentMethodManagerFail(errorMessage(error)));
  }
}
function* onCreatePaymentMethodManager({ payload }) {
  try {
    const response = yield call(PaymentMethodManagerService.createPaymentMethodManager, payload);
    yield put(createPaymentMethodManagerSuccess(response));
  } catch (error) {
    yield put(createPaymentMethodManagerFail(errorMessage(error)));
  }
}

function* onDetailPaymentMethodManager({ payload }) {
  try {
    const response = yield call(PaymentMethodManagerService.detailPaymentMethodManager, payload);
    yield put(detailPaymentMethodManagerSuccess(response));
  } catch (error) {
    yield put(detailPaymentMethodManagerFail(errorMessage(error)));
  }
}

function* onDeletePaymentMethodManager({ payload }) {
  try {
    const response = yield call(PaymentMethodManagerService.deletePaymentMethodManager, payload);
    yield put(deletePaymentMethodManagerSuccess(response));
  } catch (error) {
    yield put(deletePaymentMethodManagerFail(errorMessage(error)));
  }
}

function* onActivePaymentMethodManager({ payload }) {
  try {
    const response = yield call(PaymentMethodManagerService.activePaymentMethodManager, payload);
    yield put(activePaymentMethodManagerSuccess(response));
  } catch (error) {
    yield put(activePaymentMethodManagerFail(errorMessage(error)));
  }
}

function* userManagementSaga() {
  yield takeEvery(PAYMENT_METHOD_MANAGER_LIST, fetchListPaymentMethodManager);
  yield takeEvery(PAYMENT_METHOD_MANAGER_CREATE, onCreatePaymentMethodManager);
  yield takeEvery(PAYMENT_METHOD_MANAGER_DETAIL, onDetailPaymentMethodManager);
  yield takeEvery(PAYMENT_METHOD_MANAGER_UPDATE, onUpdatePaymentMethodManager);
  yield takeEvery(PAYMENT_METHOD_MANAGER_DELETE, onDeletePaymentMethodManager);
}

export default userManagementSaga;
